<template>
  <ModalFilterTransaction
    v-if="modalShowFilterTransaction"
    :filter="filter"
    @closeModal="closeModal"
    @submitFilter="submitFilter"
  />
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Laporan Transaksi" />
      <div
        class="border-t-2 border-primary bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100"
      >
        <div
          v-if="!isConnected"
          class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4"
          role="alert"
        >
          <p class="font-bold">Connection Status</p>
          <p>Attempting to connect to real-time updates...</p>
        </div>
        <div id="table-header" class="mb-5 flex justify-between items-end">
          <div class="mb-5 flex justify-between">
            <AddButton
              to_url="#"
              button_text="Filter"
              button_class="text-base py-2 font-medium"
              @click="showModal"
            />
          </div>
        </div>
        <div v-if="isLoading" class="flex justify-center items-center py-4">
          <div
            class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"
          ></div>
        </div>
        <div v-else class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Kode</TableHeadCell>
                    <TableHeadCell>Nama Pelanggan</TableHeadCell>
                    <TableHeadCell>Staff</TableHeadCell>
                    <TableHeadCell>Metode pembayaran</TableHeadCell>
                    <TableHeadCell>Sub Total</TableHeadCell>
                    <TableHeadCell>tax</TableHeadCell>
                    <TableHeadCell>Service Charge</TableHeadCell>
                    <TableHeadCell>Diskon</TableHeadCell>
                    <TableHeadCell>Grand Total</TableHeadCell>
                    <TableHeadCell>Keterangan</TableHeadCell>
                    <TableHeadCell>Bayar</TableHeadCell>
                    <TableHeadCell>Waktu Transaksi</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Cash Register</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="allSalesOrders.length == 0">
                    <TableCell
                      colspan="6"
                      customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor
                    >
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow
                    v-for="transaction in allSalesOrders"
                    :key="transaction.id"
                  >
                    <TableCell>{{ transaction.id }}</TableCell>
                    <TableCell>{{ transaction.code }}</TableCell>
                    <TableCell>{{ transaction.customer_name }}</TableCell>
                    <TableCell>{{
                      this.allMarketings?.find(
                        (m) => m.id == transaction.marketing_id
                      )?.name
                    }}</TableCell>
                    <TableCell>{{
                      this.formatPaymentMethodeName(transaction.payment_method_id)
                    }}</TableCell>
                    <TableCell>{{ transaction.sub_total }}</TableCell>
                    <TableCell>{{ transaction.tax }}</TableCell>
                    <TableCell>{{ transaction.service_charge }}</TableCell>
                    <TableCell>{{ transaction.discount }}</TableCell>
                    <TableCell>{{ transaction.grand_total }}</TableCell>
                    <TableCell>{{ transaction.note }}</TableCell>
                    <TableCell>{{ transaction.payment_amount }}</TableCell>
                    <TableCell>{{ formatTime(transaction.updatedAt) }}</TableCell>
                    <TableCell>{{ transaction.status }}</TableCell>
                    <TableCell
                      >{{ formatTime(transaction.cash_register.time_start) }} -
                      {{ formatTime(transaction.cash_register.time_end) }}</TableCell
                    >
                  </TableRow>
                </TableBody>
              </TableComponent>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import IndexView from "@/views/IndexView.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import ModalFilterTransaction from "./modals/ModalFilterTransaction.vue";
import { io } from "socket.io-client";
import { mapGetters } from "vuex";
import ViewContainer from "@/components/ViewContainer.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import { formatTime } from "@/helpers/formatTime";
import { paymentMethode } from "@/helpers/constanta";

export default {
  name: "TransactionView",
  components: {
    PageTitle,
    IndexView,
    AddButton,
    ModalFilterTransaction,
    ViewContainer,
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
  },
  data() {
    return {
      paymentMethode,
      modalShowFilterTransaction: false,
      isBlur: false,
      listTransaction: [],
      socket: null,
      message: "",
      messages: [],
      isConnected: false,
      isLoading: false,
      currentPage: 1,
      totalPages: 1,
      filter: {},
    };
  },
  async created() {
    await this.connectWebSocket();
    await this.fetchSalesOrders();
    await this.fetchAdditionalData();
    console.log("allSalesOrders", this.allSalesOrders);
  },
  computed: {
    // ...mapGetters('sales_orders', ['allSalesOrders']),
    ...mapGetters("reports", ["allSalesOrders"]),
    ...mapGetters("tables", ["allTables"]),
    ...mapGetters("marketings", ["allMarketings"]),
    ...mapGetters("payment_methods", ["allPaymentMethods"]),
  },
  beforeUnmount() {
    try {
      if (this.socket) {
        // Remove all listeners to prevent memory leaks
        this.socket.removeAllListeners();
        this.socket.disconnect();
        this.socket = null;
      }
      this.isConnected = false;
      this.listTransaction = [];
      this.messages = [];
    } catch (error) {
      console.error("Error during cleanup:", error);
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchSalesOrders({ page: newVal });
      },
    },
  },
  methods: {
    formatTime,
    formatPaymentMethodeName(paymentMethodId) {
      const paymentMethod = this.allPaymentMethods.find(paymentMethod => paymentMethod.id === paymentMethodId);
      return paymentMethode?.[paymentMethod?.name?.toUpperCase()] || paymentMethod?.name || '-';
    },
    async fetchSalesOrders(params = {}) {
      await this.$store.dispatch("reports/fetchAllSalesOrders", params);
    },
    async fetchAdditionalData() {
      await this.$store.dispatch("tables/fetchTables", { limit: 1000 });
      await this.$store.dispatch("marketings/fetchMarketings", { limit: 1000 });
      await this.$store.dispatch("payment_methods/fetchPaymentMethods", {
        limit: 1000,
      });
    },
    connectWebSocket() {
      try {
        this.socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
          reconnection: true, // Enable auto-reconnection
          reconnectionAttempts: 5, // Maximum number of reconnection attempts
          timeout: 10000, // Connection timeout in milliseconds
        });

        this.socket.on("connect_error", (error) => {
          this.messages.push(error.message);
          this.isConnected = false;
        });

        this.socket.on("disconnect", (reason) => {
          this.messages.push(reason);
          this.isConnected = false;
        });

        // Menerima pesan dari server
        this.socket.on("serverMessage", (data) => {
          this.handleWebSocketMessage(data);
          this.messages.push(data.message);
        });

        this.socket.on("welcome", (data) => {
          this.messages.push(data.message);
        });

        this.socket.on("new_items", (order) => {
          this.handleWebSocketMessage(order);
        });

        this.socket.on("update_items", (order) => {
          this.handleWebSocketMessage(order);
        });

        this.socket.on("delete_items", (order) => {
          this.handleWebSocketMessage(order);
        });

        this.socket.on("connect", () => {
          this.isConnected = true;
        });

        this.socket.on("error", (error) => {
          this.messages.push(error.message);
          this.isConnected = false;
        });

        this.handleReconnect();
      } catch (error) {
        this.isConnected = false;
      }
    },
    sendMessage() {
      // Kirim pesan ke server
      this.socket.emit("clientMessage", this.message);
      this.message = ""; // Reset input
    },
    handleWebSocketMessage(data) {
      this.isLoading = true;
      try {
        let index;

        // Validasi data terlebih dahulu
        if (!data || !data.type) {
          return;
        }

        switch (data.type) {
          case "INITIAL_DATA":
            if (Array.isArray(data.transactions)) {
              this.listTransaction = data.transactions;
              this.fetchSalesOrders();
            } else {
              console.warn("Invalid transactions data format:", data);
            }
            break;
          case "NEW_ITEMS":
            if (data.items && data.route == "sales-order") {
              this.listTransaction.unshift(data.items);
              this.fetchSalesOrders();
            }
            break;
          case "UPDATE_ITEMS":
            if (data.items && data.items.id && data.route == "sales-order") {
              index = this.listTransaction.findIndex(
                (t) => t.id === data.items.id
              );
              if (index !== -1) {
                this.listTransaction.splice(index, 1, data.items);
              }
              this.fetchSalesOrders();
            }
            break;
          case "DELETE_ITEMS":
            if (data.id && data.route == "sales-order") {
              this.listTransaction = this.listTransaction.filter(
                (transaction) => String(transaction.id) !== String(data.id)
              );
              this.fetchSalesOrders();
            }
            break;
          default:
            console.warn("Unknown message type:", data.type);
        }
      } catch (error) {
        console.error("Error handling websocket message:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleReconnect() {
      if (this.socket) {
        this.socket.on("reconnect_attempt", (attemptNumber) => {
          console.log(`Reconnection attempt ${attemptNumber}`);
        });

        this.socket.on("reconnect", () => {
          console.log("Reconnected successfully");
          this.isConnected = true;
          // Mungkin perlu memuat ulang data
          this.socket.emit("requestInitialData");
        });

        this.socket.on("reconnect_failed", () => {
          console.log("Failed to reconnect");
          this.isConnected = false;
        });
      }
    },
    showModal() {
      this.modalShowFilterTransaction = true;
      this.isBlur = true;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowFilterTransaction = false;
        this.isBlur = false;
      }, 200);
    },
    submitFilter(filter) {
      let params = {};
      if (filter.capacity) {
        params.capacity = filter.capacity;
      }

      if (filter.type) {
        params.order_type = filter.type;
      }

      if (filter.status) {
        params.status = filter.status;
      }

      if (filter.marketing_id) {
        params.marketing_id = filter.marketing_id;
      }

      if (filter.payment_method_id) {
        params.payment_method_id = filter.payment_method_id;
      }

      if (filter.global_discount_id) {
        params.global_discount_id = filter.global_discount_id;
      }

      if (filter.item_category_id) {
        params.item_category_id = filter.item_category_id;
      }

      if (filter.table_id) {
        params.table_id = filter.table_id;
      }

      if (filter.cash_register_id) {
        params.cash_register_id = filter.cash_register_id;
      }

      if (filter.rangeDate) {
        params.start_date = filter.rangeDate[0];
        params.end_date = filter.rangeDate[1];
      }

      this.fetchSalesOrders(params);

      // this.allSalesOrders.filter((so) => {
      //   return (
      //     (!filter.rangeDate && (filter.rangeDate && so.created_at >= filter.rangeDate[0] && so.created_at <= filter.rangeDate[1]))
      //   );
      // });

      this.updateFilter(filter);
    },
    updateFilter(filter) {
      this.filter = filter;
    },
  },
};
</script>
